import { render, staticRenderFns } from "./CreateInstancesFromListDetailComponent.vue?vue&type=template&id=12158a13&scoped=true&"
import script from "./CreateInstancesFromListDetailComponent.vue?vue&type=script&lang=js&"
export * from "./CreateInstancesFromListDetailComponent.vue?vue&type=script&lang=js&"
import style0 from "./CreateInstancesFromListDetailComponent.vue?vue&type=style&index=0&id=12158a13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12158a13",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCardText,VCol,VRow,VSelect,VTextField})
